module.exports = {"data":{"site":{"siteMetadata":{"title":"Thibault Van Renne — Maintenance"}},"disclaimer":{"html":"<h2>通知</h2>\n<p>本公司不建议采用任何其他清洁产品，因为它们可能给你的蒂博·凡·雷恩地毯造成不可弥补与不可逆转的损害。如果你用完了蒂博·凡·雷恩除污产品，可以很方便地在本网站订购。如果你仍未能将蒂博·凡·雷恩上的污渍清除，请<a href=\"https://www.thibaultvanrenne.com/en/contact/\">与我们联络</a>。本公司能够帮助你运送、清洁或修补蒂博·凡·雷恩地毯。</p>"},"menu_labels":{"strings":{"menu_case":"神奇盒","menu_products":"本公司产品","menu_maintenance":"保养","menu_remove_stains":"如何去除污渍","menu_contact_us":"与我们联络"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-zh.json
// module id = 140
// module chunks = 60335399758886 135858987226052